import React, { useEffect } from 'react';
import {
  resetToDefaultNavbarState,
  setNavbarWithTitleNoTopNavbar,
} from '@atom/navbarAtom';
import { useLocation, useParams } from 'react-router-dom';
import SubscriptionDetail from '@components/subscription/detail/SubscriptionDetail';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { queryClient } from '../../../bootstrap';

const paymentWaitingIdAtom = atomWithStorage<string>('payment-waiting-id', '', {
  getItem(key, initialValue) {
    const storedValue = localStorage.getItem(key);
    try {
      return JSON.parse(storedValue ?? '');
    } catch {
      return initialValue;
    }
  },
  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem(key) {
    localStorage.removeItem(key);
  },
  subscribe: (key, callback) => {
    function handleChange(event: StorageEvent) {
      if (event.storageArea === localStorage && event.key === key) {
        if (
          event.oldValue !== event.newValue &&
          event.newValue &&
          event.newValue.search('paid') !== -1
        ) {
          queryClient.invalidateQueries({ queryKey: ['subscriptionData'] });
        }
        callback(event.newValue ?? '');
      }
    }
    window.addEventListener('storage', handleChange);

    return () => {
      window.removeEventListener('storage', handleChange);
    };
  },
});

const SubscriptionDetailPage = () => {
  const { subject } = useParams();
  const location = useLocation();
  const [paymentWaitingId, setPaymentWaitingId] = useAtom(paymentWaitingIdAtom);

  useEffect(() => {
    if (
      paymentWaitingId &&
      location.search &&
      location.search.search(paymentWaitingId) !== -1
    ) {
      setPaymentWaitingId('paid');
    }
  }, [paymentWaitingId, location.search]);

  useEffect(() => {
    setNavbarWithTitleNoTopNavbar(subject ?? '');
    return () => {
      resetToDefaultNavbarState();
    };
  }, []);

  return <SubscriptionDetail />;
};

export default SubscriptionDetailPage;
